import { Sentry } from '../config/sentry.config';
import type { AxiosError } from 'axios';

/**
 * Esta función procesa errores de Axios y los envía a Sentry con información enriquecida
 * @param error - Error de Axios que contiene información del request/response
 */
export function captureApiErrorTrace(error: AxiosError): void {
  const { code, reason, message } = error.response?.data || {} as any
  const { response, config } = error;
  
  const g66TraceId = response?.headers?.['g66-traceid'] || response?.headers?.['666-traceid'];
  const amazonRequestId = response?.headers?.['x-amzn-requestid'];

  Sentry.withScope((scope) => {
    scope.setContext('Trace Endpoint', {
      g66_trace_id: g66TraceId || 'sin id',
      amazon_request_id: amazonRequestId || 'sin id',
      status: response?.status || 'sin status',
      method: config?.method || 'sin method',
      endpoint: config?.url || 'sin url',
      params: config?.params || 'sin params',
      code: code || 'sin code',
      reason: reason || 'sin reason',
      message: message || 'sin message',
      timeout: config?.timeout,
      timestamp: new Date().toISOString(),
    });
    
    if (g66TraceId) scope.setTag('g66_trace_id', g66TraceId);
    if (amazonRequestId) scope.setTag('amazon_request_id', amazonRequestId);

    const enhancedError = new Error(`API Error: ${error.message}`);
    enhancedError.name = `AxiosError ${config?.url}`;

    Sentry.captureException(enhancedError);
  });
}